import { createFileRoute } from '@tanstack/react-router';
import CertificateList from '@/components/features/compliance/components/certificate-list';

export const Route = createFileRoute('/_authenticated/compliance/certificates')({
  component: CertificateList,
});
